// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, formDataBodySerializer } from '@hey-api/client-fetch';
import type { TriggerSheetsSyncApiV1SheetsSyncDataTypePostData, TriggerSheetsSyncApiV1SheetsSyncDataTypePostError, TriggerSheetsSyncApiV1SheetsSyncDataTypePostResponse, GetSyncStatusApiV1SheetsSyncSyncIdGetData, GetSyncStatusApiV1SheetsSyncSyncIdGetError, GetSyncStatusApiV1SheetsSyncSyncIdGetResponse, GetUsersApiV1UsersGetData, GetUsersApiV1UsersGetError, GetUsersApiV1UsersGetResponse, CreateUserApiV1UsersPostData, CreateUserApiV1UsersPostError, CreateUserApiV1UsersPostResponse, GetUserApiV1UsersUserIdGetData, GetUserApiV1UsersUserIdGetError, GetUserApiV1UsersUserIdGetResponse, UpdateUserMetadataApiV1UsersUserIdPatchData, UpdateUserMetadataApiV1UsersUserIdPatchError, UpdateUserMetadataApiV1UsersUserIdPatchResponse, DeleteUserApiV1UsersUserIdDeleteData, DeleteUserApiV1UsersUserIdDeleteError, DeleteUserApiV1UsersUserIdDeleteResponse, GetUserRolesApiV1UsersUserIdRolesGetData, GetUserRolesApiV1UsersUserIdRolesGetError, GetUserRolesApiV1UsersUserIdRolesGetResponse, AddUserRoleApiV1UsersUserIdRolesPostData, AddUserRoleApiV1UsersUserIdRolesPostError, AddUserRoleApiV1UsersUserIdRolesPostResponse, RemoveUserRoleApiV1UsersUserIdRolesRoleDeleteData, RemoveUserRoleApiV1UsersUserIdRolesRoleDeleteError, RemoveUserRoleApiV1UsersUserIdRolesRoleDeleteResponse, GetCurrentUserProfileApiV1UsersMeGetError, GetCurrentUserProfileApiV1UsersMeGetResponse, GetCurrentUserIdApiV1UsersMeIdGetError, GetCurrentUserIdApiV1UsersMeIdGetResponse, UploadDataApiV1UploadsDataTypePostData, UploadDataApiV1UploadsDataTypePostError, UploadDataApiV1UploadsDataTypePostResponse, GetUploadStatusApiV1UploadsUploadIdGetData, GetUploadStatusApiV1UploadsUploadIdGetError, GetUploadStatusApiV1UploadsUploadIdGetResponse, GetUploadErrorsApiV1UploadsUploadIdErrorsGetData, GetUploadErrorsApiV1UploadsUploadIdErrorsGetError, GetUploadErrorsApiV1UploadsUploadIdErrorsGetResponse, GetMissingDataApiV1MissingDataDataTypeGetData, GetMissingDataApiV1MissingDataDataTypeGetError, GetMissingDataApiV1MissingDataDataTypeGetResponse, AddMissingDataApiV1MissingDataAddPostData, AddMissingDataApiV1MissingDataAddPostError, AddMissingDataApiV1MissingDataAddPostResponse, GetUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGetData, GetUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGetError, GetUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGetResponse, GetRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGetData, GetRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGetError, GetRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGetResponse, GetRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGetData, GetRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGetError, GetRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGetResponse, GetProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGetData, GetProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGetError, GetProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGetResponse, LoginAuthLoginPostError, LoginAuthLoginPostResponse, LogoutAuthLogoutPostError, LogoutAuthLogoutPostResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Trigger Sheets Sync
 * Trigger synchronization for a specific data type from Google Sheets
 */
export const triggerSheetsSyncApiV1SheetsSyncDataTypePost = <ThrowOnError extends boolean = false>(options: Options<TriggerSheetsSyncApiV1SheetsSyncDataTypePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<TriggerSheetsSyncApiV1SheetsSyncDataTypePostResponse, TriggerSheetsSyncApiV1SheetsSyncDataTypePostError, ThrowOnError>({
        ...options,
        url: '/api/v1/sheets_sync/{data_type}'
    });
};

/**
 * Get Sync Status
 * Get the status of a specific sheets sync operation
 */
export const getSyncStatusApiV1SheetsSyncSyncIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSyncStatusApiV1SheetsSyncSyncIdGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSyncStatusApiV1SheetsSyncSyncIdGetResponse, GetSyncStatusApiV1SheetsSyncSyncIdGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/sheets_sync/{sync_id}'
    });
};

/**
 * List Users
 * Get all users in the system
 */
export const getUsersApiV1UsersGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsersApiV1UsersGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersApiV1UsersGetResponse, GetUsersApiV1UsersGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/users'
    });
};

/**
 * Create User
 * Create a new user in the system
 */
export const createUserApiV1UsersPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserApiV1UsersPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateUserApiV1UsersPostResponse, CreateUserApiV1UsersPostError, ThrowOnError>({
        ...options,
        url: '/api/v1/users'
    });
};

/**
 * Get User
 * Get a specific user by ID
 */
export const getUserApiV1UsersUserIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUserApiV1UsersUserIdGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserApiV1UsersUserIdGetResponse, GetUserApiV1UsersUserIdGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}'
    });
};

/**
 * Update User Metadata
 * Update a user's metadata
 */
export const updateUserMetadataApiV1UsersUserIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateUserMetadataApiV1UsersUserIdPatchData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateUserMetadataApiV1UsersUserIdPatchResponse, UpdateUserMetadataApiV1UsersUserIdPatchError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}'
    });
};

/**
 * Delete User
 * Soft delete a user
 */
export const deleteUserApiV1UsersUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteUserApiV1UsersUserIdDeleteData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserApiV1UsersUserIdDeleteResponse, DeleteUserApiV1UsersUserIdDeleteError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}'
    });
};

/**
 * Get User Roles
 * Get the roles assigned to a user
 */
export const getUserRolesApiV1UsersUserIdRolesGet = <ThrowOnError extends boolean = false>(options: Options<GetUserRolesApiV1UsersUserIdRolesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserRolesApiV1UsersUserIdRolesGetResponse, GetUserRolesApiV1UsersUserIdRolesGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}/roles'
    });
};

/**
 * Add User Role
 * Add a role to a user
 */
export const addUserRoleApiV1UsersUserIdRolesPost = <ThrowOnError extends boolean = false>(options: Options<AddUserRoleApiV1UsersUserIdRolesPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddUserRoleApiV1UsersUserIdRolesPostResponse, AddUserRoleApiV1UsersUserIdRolesPostError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}/roles'
    });
};

/**
 * Remove User Role
 * Remove a role from a user
 */
export const removeUserRoleApiV1UsersUserIdRolesRoleDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveUserRoleApiV1UsersUserIdRolesRoleDeleteData, ThrowOnError>) => {
    return (options?.client ?? client).delete<RemoveUserRoleApiV1UsersUserIdRolesRoleDeleteResponse, RemoveUserRoleApiV1UsersUserIdRolesRoleDeleteError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{user_id}/roles/{role}'
    });
};

/**
 * Get Current User
 * Get the currently authenticated user's profile
 */
export const getCurrentUserProfileApiV1UsersMeGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCurrentUserProfileApiV1UsersMeGetResponse, GetCurrentUserProfileApiV1UsersMeGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/me'
    });
};

/**
 * Get Current User ID
 * Get the ID of the currently authenticated user
 */
export const getCurrentUserIdApiV1UsersMeIdGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCurrentUserIdApiV1UsersMeIdGetResponse, GetCurrentUserIdApiV1UsersMeIdGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/me/id'
    });
};

/**
 * Upload CSV with Date Range
 * Upload CSV file with data plus a date range
 */
export const uploadDataApiV1UploadsDataTypePost = <ThrowOnError extends boolean = false>(options: Options<UploadDataApiV1UploadsDataTypePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<UploadDataApiV1UploadsDataTypePostResponse, UploadDataApiV1UploadsDataTypePostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/api/v1/uploads/{data_type}'
    });
};

/**
 * Get Upload Status
 * Get the status of a specific upload
 */
export const getUploadStatusApiV1UploadsUploadIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUploadStatusApiV1UploadsUploadIdGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUploadStatusApiV1UploadsUploadIdGetResponse, GetUploadStatusApiV1UploadsUploadIdGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/uploads/{upload_id}'
    });
};

/**
 * Get Upload Errors
 * Get validation errors for a specific upload
 */
export const getUploadErrorsApiV1UploadsUploadIdErrorsGet = <ThrowOnError extends boolean = false>(options: Options<GetUploadErrorsApiV1UploadsUploadIdErrorsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUploadErrorsApiV1UploadsUploadIdErrorsGetResponse, GetUploadErrorsApiV1UploadsUploadIdErrorsGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/uploads/{upload_id}/errors'
    });
};

/**
 * Get Missing Data
 * Get missing data mappings for the specified data type
 */
export const getMissingDataApiV1MissingDataDataTypeGet = <ThrowOnError extends boolean = false>(options: Options<GetMissingDataApiV1MissingDataDataTypeGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMissingDataApiV1MissingDataDataTypeGetResponse, GetMissingDataApiV1MissingDataDataTypeGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/missing-data/{data_type}'
    });
};

/**
 * Add Missing Data
 * Add missing data mappings for the specified data type and update Google Sheets
 */
export const addMissingDataApiV1MissingDataAddPost = <ThrowOnError extends boolean = false>(options: Options<AddMissingDataApiV1MissingDataAddPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<AddMissingDataApiV1MissingDataAddPostResponse, AddMissingDataApiV1MissingDataAddPostError, ThrowOnError>({
        ...options,
        url: '/api/v1/missing-data/add'
    });
};

/**
 * Get Unique Field Values
 * Get unique values for the specified field type
 */
export const getUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGet = <ThrowOnError extends boolean = false>(options: Options<GetUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGetResponse, GetUniqueFieldValuesApiV1MissingDataUniqueValuesDataTypeGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/missing-data/unique-values/{data_type}'
    });
};

/**
 * Get Detailed Revenue Pivot Table
 * Get a pivot table of revenue by sales rep, customer group, product class, and week
 */
export const getRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGet = <ThrowOnError extends boolean = false>(options?: Options<GetRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGetResponse, GetRevenuePivotBySalesRepApiV1PivotTablesRevenueBySalesRepGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/pivot-tables/revenue-by-sales-rep'
    });
};

/**
 * Get Detailed Revenue Pivot Table as CSV
 * Get a pivot table of revenue by sales rep, customer group, product class, and week as a CSV file
 */
export const getRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGet = <ThrowOnError extends boolean = false>(options?: Options<GetRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGetResponse, GetRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/pivot-tables/revenue-by-sales-rep/csv'
    });
};

/**
 * Get Detailed Profit Pivot Table as CSV
 * Get a pivot table of profit by sales rep, customer group, product class, and week as a CSV file
 */
export const getProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGet = <ThrowOnError extends boolean = false>(options?: Options<GetProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGetResponse, GetProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGetError, ThrowOnError>({
        ...options,
        url: '/api/v1/pivot-tables/profit-by-sales-rep/csv'
    });
};

/**
 * Login
 * Authenticate user using Auth0 token.
 *
 * Args:
 * token: Auth0 token in Authorization header
 *
 * Returns:
 * User information if authentication is successful
 *
 * Raises:
 * HTTPException: If authentication fails
 */
export const loginAuthLoginPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<LoginAuthLoginPostResponse, LoginAuthLoginPostError, ThrowOnError>({
        ...options,
        url: '/auth/login'
    });
};

/**
 * Logout
 * Logout user and invalidate Auth0 token.
 *
 * Args:
 * token: Auth0 token in Authorization header
 *
 * Returns:
 * Success message
 *
 * Raises:
 * HTTPException: If logout fails
 */
export const logoutAuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<LogoutAuthLogoutPostResponse, LogoutAuthLogoutPostError, ThrowOnError>({
        ...options,
        url: '/auth/logout'
    });
};